import { ReactComponent as Error } from '../../assets/svg/error.svg';

export default Error;
